var React = require('react');

function Categorys (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Category"},[React.createElement("rect",{"id":"Rectangle 2","x":"0.916626","y":"1.33325","width":"5.83333","height":"5.83333","rx":"2.08333","stroke":"#121212","strokeWidth":"1.5","key":0}),React.createElement("rect",{"id":"Rectangle 4","x":"0.916626","y":"9.66663","width":"5.83333","height":"5.83333","rx":"2.08333","stroke":"#121212","strokeWidth":"1.5","key":1}),React.createElement("rect",{"id":"Rectangle 3","x":"9.24994","y":"1.33325","width":"5.83333","height":"5.83333","rx":"2.08333","stroke":"#121212","strokeWidth":"1.5","key":2}),React.createElement("rect",{"id":"Rectangle 5","x":"9.24994","y":"9.66663","width":"5.83333","height":"5.83333","rx":"2.08333","stroke":"#121212","strokeWidth":"1.5","key":3})]));
}

Categorys.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Categorys;

Categorys.default = Categorys;
